import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tabs } from '../../../domain/tabs.interface';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent {
  @Input() view: string = '1';
  @Input() blocked: boolean = false;
  @Input() tabs: Tabs[] = [];
  @Output() private activeTab = new EventEmitter<string>();
  constructor() {}

  selectionContent(value: string) {
    if(!this.blocked && value !== this.view) {
      this.view = value;      
    }
    this.activeTab.emit(value);
  }
}
